import BehaviorOperand from './behavior_operand';

export default class BehaviorValueOperand extends BehaviorOperand {
	_value;

	constructor(props = {}) {
		super(props);
	}

	get value() {
		return this._value;
	}

	set value(value) {
		this._value = value;
	}
}
